import { render, staticRenderFns } from "./SliderMultiple.vue?vue&type=template&id=5604c448&"
import script from "./SliderMultiple.vue?vue&type=script&lang=js&"
export * from "./SliderMultiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports